import { CloseCircleOutlined, ReloadOutlined } from "@ant-design/icons";
import {
    Button,
    Col,
    Form,
    Image,
    Input,
    Row,
    Select,
    Tabs,
} from "antd";
import { useState, useEffect } from "react";
import MainLayout from "../../../components/mainLayout";
import "./Banner.scss";
import UploadMultiple from '../../../commons/UploadMultiple/UploadMultiple';
import EventForm from '../../../components/form/eventForm';
import { authApis } from "../../../services/authApi";
import { nofication } from '../../../commons/Nofication';
import { useParams } from 'react-router-dom';
import { ROOT_URL } from "../../../constants/api";
import BackButton from "../../../commons/BackButton";
import { useNavigate } from 'react-router-dom';

const { TabPane } = Tabs;
const style = { padding: "8px 20px" };
const onChange = (key) => {
    console.log(key);
};

const AddBannerInvestor = () => {
    const history = useNavigate();
    const [fileList, setFileList] = useState([]);
    const [imageUrl, setImageUrl] = useState([]);
    const [idsRemove, setIdsRemove] = useState([]);
    const [imgCurrent, setImgCurrent] = useState([]);
    const [fields, setFields] = useState([]);
    const [form] = Form.useForm();
    let { id } = useParams();
    const [content, setContent] = useState({
        content_vi: "",
        // content_en: "",
        // content_kr: "",
        // content_cn: "",
        // content_jp: "",

    });
    const [color, setColor] = useState('#ffffff');
    const onChangeContentValue = (lang) => {
        console.log('lang')
    }
    useEffect(() => {
        if (id) {
            authApis
                .getDetailEvent(id)
                .then((data) => {
                    if (data.status_code === 200) {
                        // Map documents thành fields cho Form.List
                        const fields = (data.documents || []).map(doc => ({
                            id: doc.id,
                            name_vi: doc.name_vi,
                            link: doc.link,
                        }));
                        form.setFieldsValue({
                            ...data.event,
                            fields,
                        });
                        setColor(data.event?.color ?? '#1e6c4f');
                        setContent({
                            content_vi: data.event?.content_vi ?? '<p></p>',
                        });
                    } else {
                        nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                    }
                })
                .catch((errors) => {
                    nofication('error', 'Thất bại', 'Không kết nối được server');
                    console.log(errors)
                });
        }
    }, [id]);

    useEffect(() => {
        if (form.getFieldValue('color')) {
            setColor(form.getFieldValue('color'));
        }
    }, [form]);

    const onFinish = async () => {
        const values = form.getFieldValue();
        values.logo = undefined;
        const formData = new FormData();
        for (var key in values) {
            if (key === 'content_vi' || key === 'content_en' || key === 'content_kr' || key === 'content_cn' || key === 'content_jp') {
                formData.append(key, values[key]?.editor ? values[key]?.editor.getData() : values[key]);
            }
            else if (key === 'fields') {
                formData.append(key, JSON.stringify(values[key]));
            } else {
                formData.append(key, values[key]);
            }
        }
        id && formData.append('id', id);


        // if (fileList && fileList.length !== 0){
        //     for (let i = 0; i < fileList.length; i++) {
        //         formData.append('logo' + i, fileList[i])
        //         console.log('fileList[i]',fileList[i])
        //     }
        // }
        // formData.append('total', fileList && fileList.length)
        // formData.append('idsRemove', idsRemove)
        // formData.append('type', 0)
        await authApis
            .addEvent(formData)
            .then((data) => {
                if (data.status_code === 200) {
                    // setImageUrl([...data.images])
                    // setFileList([])
                    nofication('success', 'Thành công', 'Cập nhật thành công!');
                    form.resetFields();
                    setContent({
                        content_vi: '',
                    });
                    history('/tuyen-sinh/chuong-trinh/');
                } else {
                    nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                }
            })
            .catch((errors) => {
                nofication('error', 'Thất bại', 'Không kết nối được server');
                console.log(errors)
            });
    };

    return (
        <MainLayout
            isShowActionHeader={false}
            title="Chương trình"
            link="/tuyen-sinh/chuong-trinh/"
            titleNew="Tuyển sinh / Chương trình / Tạo mới"
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                colon={true}
                initialValues={{ type: 1 }}
            >
                <Row gutter={16} style={{ minHeight: "873px" }}>
                    <Col span={24} className='pad'>
                        <div className="box-class">
                            <Tabs defaultActiveKey="1" onChange={onChange}>
                                <TabPane tab="Tiếng việt" key="1">
                                    <EventForm lang={'vi'} onChangeContentValue={onChangeContentValue} content={content} id={id} />
                                </TabPane>
                            </Tabs>
                            <Form.Item label="Thời gian bắt đầu" colon={true} name="date_start">
                                <Input type="text" />
                            </Form.Item>
                            <Form.Item label="Link form đăng ký" colon={true} name="link_form">
                                <Input type="text" />
                            </Form.Item>
                            <Form.Item label="Màu sắc" colon={true} name="color">
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Input
                                        type="color"
                                        value={color}
                                        onChange={e => {
                                            setColor(e.target.value);
                                            form.setFieldsValue({ color: e.target.value });
                                        }}
                                        style={{ width: 60, padding: 0, border: 'none', background: 'none', verticalAlign: 'middle' }}
                                    />
                                    <Input
                                        value={color}
                                        onChange={e => {
                                            setColor(e.target.value);
                                            form.setFieldsValue({ color: e.target.value });
                                        }}
                                        style={{ width: 90, marginLeft: 10 }}
                                        maxLength={7}
                                        placeholder="#ffffff"
                                    />
                                    <span style={{
                                        display: 'inline-block',
                                        width: 30,
                                        height: 30,
                                        marginLeft: 10,
                                        border: '1px solid #ccc',
                                        verticalAlign: 'middle',
                                        background: color || '#fff'
                                    }} />
                                </div>
                            </Form.Item>
                            <Form.Item label="Vị trí" colon={true} name="position">
                                <Input type="number" />
                            </Form.Item>
                            <Form.Item>
                                <Row
                                    justify="space-between"
                                    style={{ marginTop: 30 }}
                                >
                                    <Col>
                                        <Button
                                            type="primary"
                                            icon={<ReloadOutlined />}
                                            htmlType="submit"
                                        >
                                            Submit
                                        </Button>
                                        <Button
                                            htmlType="reset"
                                            style={{
                                                background: "#6c757d",
                                                color: "white",
                                                marginLeft: 20,
                                            }}
                                        >
                                            Reset
                                        </Button>
                                    </Col>
                                    <Col>
                                        <BackButton />
                                    </Col>
                                </Row>
                            </Form.Item>
                        </div>
                    </Col>
                </Row>
            </Form>
        </MainLayout>
    );
};

export default AddBannerInvestor;
